import type { Company, CompanyRequest } from "@/modules/companies/client/api/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

export const COMPANY_QUERY_KEY = "companies::company"
export const ERROR_SERVER_SIDE_COMPANY = "error_server_side_company"
export const COMPANY_PAGE_TYPE = {
  NONE: "COMPANY_PAGE_TYPE_NONE",
  PREMIUM: "COMPANY_PAGE_TYPE_PREMIUM",
  STANDARD: "COMPANY_PAGE_TYPE_STANDARD",
} as const

const COMPANY_ENDPOINT = "/jobteaser.company.services.company_page.v1alpha1/CompanyPageService/GetCompanyPage"

export type CompanyRedirect = {
  responseType: "redirect"
  newPermalink: string
}

export const getCompany = async ({
  nextRequest,
  ...restParams
}: CompanyRequest): Promise<Company | CompanyRedirect> => {
  const queryParams = restParams.schoolPermalink === "www" ? { ...restParams, schoolPermalink: undefined } : restParams

  return fetcher(COMPANY_ENDPOINT, {
    nextRequest,
    requestInit: { body: JSON.stringify(queryParams), method: "POST" },
    serviceDomain: "GATEWAY_API",
  })
    .then(async response =>
      getResultFromResponse<Company, Company, CompanyRedirect>({
        onHttpRedirect: () => ({
          newPermalink: response.headers.get("location") || "",
          responseType: "redirect",
        }),
        transformResult: toCamelCaseKeys,
      })(response)
    )
    .catch(handleFetchError(COMPANY_ENDPOINT, restParams))
}
